/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Loading/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import LoadingBar from 'DesignSystem/LoadingBar/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Loading({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/Properties/Content/Content/Content/ActiveStep/Http/Loading"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<LoadingBar
  viewPath={`${viewPath}/LoadingBar`}
 width="100%"
 marginTop={dtSpaceXs}
 height={dtSpaceXs}
/>
{children}
</React.Fragment>)
}